import React, { useState, useEffect } from "react";
import {
  Layout,
  Modal,
  Tooltip,
  Button,
  Segmented,
  Typography,
  Space,
} from "antd";
import { DatePicker } from "../../../components/antOverrides";
import { CloseOutlined } from "@ant-design/icons";
import { useMedia } from "react-media";
import RecurrentEventsReplacements from "../../../components/scheduling/replacements/recurrentEvents/RecurrentEventsReplacements";
import SingleEventsReplacements from "../../../components/scheduling/replacements/singleEvents/SingleEventsReplacements";
import ReplacementsWrapper from "./index.style";
import EmployeeDetails from "../../employeeScheduling/components/EmployeeDetails";
import { useSelector } from "react-redux";
import ReplacedByEventsModal from "./ReplacedByEventsModal";
import moment from "moment";
import { useIntl } from "react-intl";
const { Title } = Typography;

const GLOBAL_MEDIA_QUERIES = {
  small: "(max-width: 899px)",
};
const { RangePicker } = DatePicker;

const ReplacementsModal = (props) => {
  const {
    visible,
    onHide,
    triggerFetch,
    triggerQueryTimestamp,
    absenceValues,
    timeFrameValues,
    abscenceActions,
    noConflicts,
    hasAbsencesConflicts,
    title,
    subTitle,
  } = props;
  const intl = useIntl();
  const singleEventsTxt = intl.formatMessage({
    id: "app.scheduling.singleEventsTxt",
  });
  const recurrentEventsTxt = intl.formatMessage({
    id: "app.scheduling.recurrentEventsTxt",
  });

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [replacedBy, setReplacedBy] = useState([]);
  const [view, setView] = useState(singleEventsTxt);
  const [replacedByVisible, setReplacedByVisible] = useState(false);
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );

  const closeModal = () => {
    onHide();
  };

  useEffect(() => {
    if (!visible) {
      setView(singleEventsTxt);
      setFromDate(null);
      setToDate(null);
    }
  }, [visible]);

  useEffect(() => {
    if (absenceValues && view === singleEventsTxt) {
      setFromDate(absenceValues.effective_from);
      setToDate(absenceValues.effective_to);
    }
  }, [absenceValues, view]);

  useEffect(() => {
    if (timeFrameValues && view === singleEventsTxt) {
      setFromDate(timeFrameValues.effective_from);
      setToDate(timeFrameValues.effective_to);
    }
  }, [timeFrameValues, view]);

  const onChange = (val) => {
    let from = null;
    let to = null;
    if (val) {
      from = moment(val[0]).startOf("day").format();
      to = moment(val[1]).endOf("day").format();
    }
    setFromDate(from);
    setToDate(to);
  };

  const onViewChange = (val) => {
    setView(val);
  };

  const onShowSingleReplacements = () => {
    setReplacedByVisible(true);
  };

  const hideSingleReplacements = () => {
    setReplacedByVisible(false);
  };

  const setReplacedByEvents = (data) => {
    setReplacedBy(data);
  };

  return (
    <Modal
      width={"vw"}
      style={{
        height: "100vh",
        maxWidth: "100vw",
        position: "absolute",
        top: 0,
        left: 0,
      }}
      styles={{
        body: {
          height: "100vh",
          width: "100vw",
          padding: "40px 20px 20px 20px",
        },
      }}
      className={"no-padding no-border-radius"}
      closable={false}
      open={visible}
      footer={null}
      destroyOnClose={true}
    >
      <Layout
        style={{
          background: "transparent",
          paddingTop: "20px",
        }}
      >
        <div style={{ position: "absolute", right: 60, top: 10 }}>
          <Title level={4} style={{ margin: 0 }}>
            {title}
          </Title>
          <Title level={5} style={{ margin: "0 0 10px 0" }}>
            {subTitle}
          </Title>
        </div>

        {matches.small ? null : (
          <div style={{ position: "absolute", left: "10px", top: "10px" }}>
            <EmployeeDetails record={activeEmployee} />
          </div>
        )}
        <Tooltip title="close">
          <Button
            onClick={closeModal}
            size="large"
            style={{ position: "absolute", right: 10, top: 10 }}
            shape="circle"
            icon={<CloseOutlined />}
          />
        </Tooltip>
        {hasAbsencesConflicts || !absenceValues || timeFrameValues ? (
          <ReplacementsWrapper>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingBottom: "10px",
                paddingTop: "30px",
              }}
            >
              <RangePicker
                onChange={onChange}
                value={
                  fromDate && toDate
                    ? [moment(fromDate), moment(toDate)]
                    : undefined
                }
                disabled={
                  view === singleEventsTxt && (absenceValues || timeFrameValues)
                }
                format={"DD/MM/YYYY"}
              />
              <Space>
                {replacedBy.length > 0 && fromDate && toDate && (
                  <Button
                    style={{}}
                    type="primary"
                    onClick={onShowSingleReplacements}
                    size="normal"
                  >
                    {intl.formatMessage({
                      id: "app.actions.showReplacements",
                    })}
                  </Button>
                )}

                <Segmented
                  options={[singleEventsTxt, recurrentEventsTxt]}
                  onChange={onViewChange}
                />
              </Space>
            </div>

            {!fromDate || !toDate ? (
              <div className="inner-txt">
                <Title
                  style={{
                    fontSize: "30px",
                    fontWeight: 500,
                    lineHeight: 1.27,
                    color: "rgba(0, 0, 0, 0.85)",
                    textAlign: "center",
                  }}
                >
                  {intl.formatMessage({
                    id: "app.scheduling.pickFromToDates",
                  })}
                </Title>
              </div>
            ) : (
              <>
                <div
                  style={{
                    display: view === singleEventsTxt ? "inherit" : "none",
                  }}
                >
                  <SingleEventsReplacements
                    fromDate={fromDate}
                    toDate={toDate}
                    activeEmployee={activeEmployee}
                    triggerFetch={triggerFetch}
                    triggerQueryTimestamp={triggerQueryTimestamp}
                    abscenceActions={abscenceActions}
                    setReplacedByEvents={setReplacedByEvents}
                  />
                </div>
                <div
                  style={{
                    display: view !== singleEventsTxt ? "inherit" : "none",
                  }}
                >
                  <RecurrentEventsReplacements
                    fromDate={fromDate}
                    toDate={toDate}
                    activeEmployee={activeEmployee}
                    abscenceActions={abscenceActions}
                    triggerFetch={triggerFetch}
                    triggerQueryTimestamp={triggerQueryTimestamp}
                  />
                </div>
              </>
            )}
          </ReplacementsWrapper>
        ) : (
          noConflicts
        )}
      </Layout>
      <ReplacedByEventsModal
        visible={replacedByVisible}
        hide={hideSingleReplacements}
        events={replacedBy}
      />
    </Modal>
  );
};

export default ReplacementsModal;
